import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import WhyUs from "./components/WhyUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const whyRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>
          Gauweng SA | Business & Technology Management | Inspired Business
          Solutions | Software, SEO, Data & QA
        </title>
        <meta
          name="description"
          content="Inspired Business Solutions. We partner with South African businesses to build powerful digital platforms, grow online presence, and make smarter data-driven decisions."
        />
        <meta
          name="keywords"
          content="Gauweng, business solutions, digital platforms, SEO, data analysis, business consulting, software development, South Africa"
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.gauweng.co.za/" />
        <meta
          property="og:title"
          content="Gauweng SA | Business & Technology Management"
        />
        <meta
          property="og:description"
          content="Inspired Business Solutions. We partner with South African businesses to build powerful digital platforms, grow their online presence, and make smarter data-driven decisions."
        />
        <meta
          property="og:image"
          content="https://www.gauweng.co.za/images/og-image.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Gauweng SA" />
        {/* <meta property="fb:pages" content="YourFacebookPageID"/> */}

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.gauweng.co.za/" />
        <meta
          property="twitter:title"
          content="Gauweng SA | Business & Technology Management"
        />
        <meta
          property="twitter:description"
          content="Inspired Business Solutions. We partner with South African businesses to build powerful digital platforms, grow their online presence, and make smarter data-driven decisions."
        />
        <meta
          property="twitter:image"
          content="https://www.gauweng.co.za/images/og-image.jpg"
        />
        <meta name="twitter:site" content="@gauweng-sa" />
        <meta name="twitter:creator" content="@gauweng-sa" />
        <link rel="canonical" href="https://www.gauweng.co.za" />
      </Helmet>
      <Navbar
        onServices={() => scrollToSection(servicesRef)}
        onAbout={() => scrollToSection(aboutRef)}
        onWhy={() => scrollToSection(whyRef)}
        onContact={() => scrollToSection(contactRef)}
      />
      <Hero
        onExplore={() => scrollToSection(servicesRef)}
        onStart={() => scrollToSection(contactRef)}
      />
      <div ref={servicesRef}>
        <Services />
      </div>
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={whyRef}>
        <WhyUs />
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>
      <Footer />
    </>
  );
}

export default App;
